module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon2.a3eca4f0.svg";